// Buy with Prime Button Styling
document.addEventListener("DOMContentLoaded", () => {
  const camelToKebab = (str) =>
    str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();

  const createPseudoStyleTag = (selector, pseudoStyles) =>
    Object.entries(pseudoStyles)
      .map(
        ([pseudo, styles]) =>
          `${selector}${pseudo} { ${Object.entries(styles)
            .map(([k, v]) => `${camelToKebab(k)}: ${v};`)
            .join(" ")} }`
      )
      .join(" ");

  const applyShadowStyles = (host, selector, styles, pseudoStyles = {}) => {
    const shadow = host.shadowRoot;
    if (!shadow) return;

    const target = shadow.querySelector(selector);
    if (!target) return;

    const { childQuery, ...baseStyles } = styles;
    Object.assign(target.style, baseStyles);

    if (childQuery) {
      const child = target.querySelector(childQuery.selector);
      if (child) Object.assign(child.style, childQuery.styles);
    }

    if (Object.keys(pseudoStyles).length > 0) {
      const styleTag = document.createElement("style");
      styleTag.textContent = createPseudoStyleTag(selector, pseudoStyles);
      shadow.appendChild(styleTag);
    }

    host.style.visibility = "visible";
  };

  const styleDeliveryPromise = (el) => {
    el.style.visibility = "hidden";

    applyShadowStyles(el, ".PromiseShell__Promise", {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    });

    applyShadowStyles(el, ".AmazonLayout__amazon-layout", {
      margin: "0",
      childQuery: {
        selector: ".AmazonLayout__content",
        styles: {
          textAlign: "center",
          fontSize: "12px",
          lineHeight: "15.6px",
          textWrapStyle: "balance",
          marginTop: "4px",
        },
      },
    });

    applyShadowStyles(el, ".AmazonLayout__content-slot", {
      marginRight: "0",
    });

    applyShadowStyles(el, ".ShopPromiseLayout__clickable", {
      margin: "0",
    });

    applyShadowStyles(el, ".ProductPageContainer__Spacer", {
      margin: "8px 0"
    });

    const generic = el.querySelector("#generic-promise-wc");
    if (generic) {
      generic.style.visibility = "hidden";

      applyShadowStyles(
        generic,
        ".amazon-pay-button",
        {
          padding: "12px 24px 10px 24px",
          height: "48px",
          backgroundColor: "#1a98ff",
          transition: "all 0.2s ease-in-out",
          borderRadius: "2px",
          childQuery: {
            selector: "svg",
            styles: { width: "118px" },
          },
        },
        {
          ":hover:enabled": {
            backgroundColor: "#1a98ff !important",
          },
          ":focus": {
            boxShadow: "none !important",
            backgroundColor: "#1a98ff !important",
          },
          ":active": {
            boxShadow: "none !important",
            backgroundColor: "#1a98ff !important",
          },
        }
      );
    }
  };

  const styleAllElements = () => {
    document
      .querySelectorAll("delivery-promise-wc")
      .forEach(styleDeliveryPromise);
  };

  let tries = 0;
  const maxTries = 50;
  let interval;

  const observeDomChanges = (target) => {
    if (!target) return;

    const observer = new MutationObserver(() => {
      tries = 0;
      startInterval();
    });

    observer.observe(target, { childList: true, subtree: true });
  };

  const attachObserverToContainer = (container) => {
    if (!container) return;
    observeDomChanges(container);
  };

  const runMainLogic = () => {
    const elements = document.querySelectorAll("delivery-promise-wc");
    if (!elements.length) return;

    let styled = false;

    elements.forEach((el) => {
      const shadow = el.shadowRoot;
      const generic = el.querySelector("#generic-promise-wc");

      if (!shadow) return;

      const shopPay = shadow.querySelector(".ShopPromiseLayout__clickable");
      const amazonLayout = shadow.querySelector(".AmazonLayout__amazon-layout");

      if (generic?.shadowRoot) {
        const btn = generic.shadowRoot.querySelector(".amazon-pay-button");

        if (amazonLayout) {
          shadow.host.classList.add("has-promise");

          const svg = btn?.querySelector("svg");
          if (svg) {
            svg.setAttribute("aria-hidden", "true");
            svg.setAttribute("role", "presentation");
            svg.setAttribute("focusable", "false");
          }

          if (!styled) {
            styleAllElements();
            styled = true;
          }

          const containerToObserve =
            shadow.querySelector(".AmazonLayout__content") || shadow;
          attachObserverToContainer(containerToObserve);
        } else {
          if (shadow.host.classList.contains("has-promise")) {
            shadow.host.classList.remove("has-promise");
            tries = 0;
            startInterval();
          }
        }
      }

      if (shopPay && !styled) {
        styleAllElements();
        styled = true;
      }
    });
  };

  const startInterval = () => {
    clearInterval(interval);
    interval = setInterval(() => {
      tries++;
      if (tries > maxTries) {
        clearInterval(interval);
        return;
      }
      runMainLogic();
    }, 100);
  };

  startInterval();

});
